(function () {
  function initBody() {
    if (document.querySelector('[data-tblue-mega-page]')) {
      document.body.classList.add('tblue-mega-template', 'tblue-js');
    }
  }

  function initGallery(scope) {
    (scope || document).querySelectorAll('.tblue-mega-product').forEach(function (section) {
      if (section.dataset.tblueGalleryReady === 'true') return;
      section.dataset.tblueGalleryReady = 'true';

      var gallery = section.querySelector('media-gallery');
      var prev = section.querySelector('[data-tblue-gallery-prev]');
      var next = section.querySelector('[data-tblue-gallery-next]');
      if (!gallery || !prev || !next) return;

      function thumbnails() {
        return Array.prototype.slice.call(gallery.querySelectorAll('button.thumbnail'));
      }

      function move(direction) {
        var items = thumbnails();
        if (!items.length) return;
        var current = items.findIndex(function (item) { return item.hasAttribute('aria-current'); });
        if (current < 0) current = 0;
        var target = (current + direction + items.length) % items.length;
        items[target].click();
        items[target].focus({ preventScroll: true });
      }

      prev.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
    });
  }

  function initAnimations(scope) {
    var root = scope || document;
    var items = root.querySelectorAll('[data-tblue-animate]');
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var duration = parseInt(el.dataset.tblueDuration || '600', 10);
        el.style.setProperty('--tblue-anim-duration', duration + 'ms');
        el.classList.add('is-visible');
        obs.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function (el) {
      if (el.dataset.tblueAnimate === 'none') {
        el.classList.add('is-visible');
      } else {
        observer.observe(el);
      }
    });
  }

  function init(scope) {
    initBody();
    initGallery(scope || document);
    initAnimations(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();